// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetContentResponse

import { hydrateWidget, type Widget, type WidgetApiResponse } from './widget.gen';
import { hydrateWidgetBusiness, type WidgetBusiness, type WidgetBusinessApiResponse } from './widgetBusiness.gen';
import { hydrateWidgetActivity, type WidgetActivity, type WidgetActivityApiResponse } from './widgetActivity.gen';
import { hydrateWidgetOffer, type WidgetOffer, type WidgetOfferApiResponse } from './widgetOffer.gen';
import { hydrateWidgetOfferCollection, type WidgetOfferCollection, type WidgetOfferCollectionApiResponse } from './widgetOfferCollection.gen';
import { hydrateWidgetSession, type WidgetSession, type WidgetSessionApiResponse } from './widgetSession.gen';
import { hydrateWidgetGiftcard, type WidgetGiftcard, type WidgetGiftcardApiResponse } from './widgetGiftcard.gen';
import { hydratePackage, type Package, type PackageApiResponse } from './package.gen';
import { hydrateCustomFieldWidget, type CustomFieldWidget, type CustomFieldWidgetApiResponse } from './customFieldWidget.gen';
import { hydrateProduct, type Product, type ProductApiResponse } from './product.gen';

export type WidgetContentApiResponse = {
	config: WidgetApiResponse;
	contractIsActive: boolean;
	business: WidgetBusinessApiResponse;
	activities: WidgetActivityApiResponse[];
	offers: Record<string, WidgetOfferApiResponse>;
	offerCollections: Record<string, WidgetOfferCollectionApiResponse>;
	sessions: Record<string, WidgetSessionApiResponse>;
	giftcards: WidgetGiftcardApiResponse[];
	packages: PackageApiResponse[];
	customFields: CustomFieldWidgetApiResponse[];
	products: ProductApiResponse[];
};

export type WidgetContent = {
	config: Widget;
	contractIsActive: boolean;
	business: WidgetBusiness;
	activities: WidgetActivity[];
	offers: Record<string, WidgetOffer>;
	offerCollections: Record<string, WidgetOfferCollection>;
	sessions: Record<string, WidgetSession>;
	giftcards: WidgetGiftcard[];
	packages: Package[];
	customFields: CustomFieldWidget[];
	products: Product[];
};

export function hydrateWidgetContent(data: WidgetContentApiResponse): WidgetContent {
	return {
		...data,
		config: hydrateWidget(data.config),
		business: hydrateWidgetBusiness(data.business),
		activities: data.activities.map(hydrateWidgetActivity),
		offers: !data.offers || Array.isArray(data.offers) ? {} : Object.fromEntries(Object.entries(data.offers).map(([k, v]) => [k, hydrateWidgetOffer(v)])),
		offerCollections: !data.offerCollections || Array.isArray(data.offerCollections) ? {} : Object.fromEntries(Object.entries(data.offerCollections).map(([k, v]) => [k, hydrateWidgetOfferCollection(v)])),
		sessions: !data.sessions || Array.isArray(data.sessions) ? {} : Object.fromEntries(Object.entries(data.sessions).map(([k, v]) => [k, hydrateWidgetSession(v)])),
		giftcards: data.giftcards.map(hydrateWidgetGiftcard),
		packages: data.packages.map(hydratePackage),
		customFields: data.customFields.map(hydrateCustomFieldWidget),
		products: data.products.map(hydrateProduct),
	};
}